import {CommonService} from "./common/commonService";



export class ServicesConfig {

    static getBaseUrl(){
        if(window.location.host.includes(":3000")){
            return "."
        }
        else{
            return "./vica/api/v1"
        }
    }

    static getBaseUrlV2(){
        if(window.location.host.includes(":3000")){
            return "./admin_sgvmap"
        }
        else{
            return "./api/v2/sgvmap"
        }
    }

    static getAbsoluteUrl(){
        if(window.location.host.includes(":3000")){
            return "."
        }
        else{
            return window.location + "api/v1"
        }
    }
}